import { Controller } from "@hotwired/stimulus"

// Автоматически обновляет статус базы знаний (polling)
export default class extends Controller {
  static values = {
    url:      String,
    interval: { type: Number, default: 8000 }
  }

  connect() {
    this.startPolling()
    this.lastStatus = null;
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.timer = setInterval(() => {
      this.fetchStatus()
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  fetchStatus() {
    fetch(this.urlValue, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        this.updateUI(data)

        // Если статус изменился на up_to_date — перезагружаем страницу
        if (data.status === "up_to_date" && data.status != this.lastStatus && this.lastStatus !== null) {
          this.stopPolling()
          window.location.reload()
        } else {
          this.lastStatus = data.status;
        }
      })
      .catch(err => console.error("Ошибка polling статуса KB:", err))
  }

  updateUI(data) {
    const badge = document.getElementById("kb-status-badge")
    const filesCount = document.getElementById("kb-files-count")
    const chunksCount = document.getElementById("kb-chunks-count")
    const lastRebuilt = document.getElementById("kb-last-rebuilt")

    if (badge) badge.textContent = data.status_label
    if (filesCount) filesCount.textContent = data.files_count
    if (chunksCount) chunksCount.textContent = data.chunks_count
    if (lastRebuilt && data.last_rebuilt_at) lastRebuilt.textContent = data.last_rebuilt_at
  }
}
